import { ActivityEntityName } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';
import { ContactMergeData } from './contact.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Item,
    displayName: "Financial Item",
    name: "FinancialItemLineMergeDataSchema"
})
export class FinancialItemLineMergeData {

    @MergeField()
    name: string;

    @MergeField()
    description: string;

    @MergeField()
    longDescription?: string;

    @MergeField()
    location?: string;

    @MergeField()
    note?: string;

    @MergeField()
    codeUoM: string;

    @MergeField()
    quantity: string;

    @MergeField()
    buyPrice?: string;

    @MergeField()
    sellPrice?: string;

    @MergeField()
    adjustment?: string;

    @MergeField()
    adjustmentType?: string;

    @MergeField()
    totalBuy?: string;

    @MergeField()
    totalSellEx?: string;

    @MergeField()
    totalSellInc?: string;

    @MergeField()
    totalAdjustment?: string;

    @MergeField()
    totalTax?: string;

    @MergeField()
    saleTaxRate?: string;

    @MergeField()
    saleGLCode?: string;
}

export const FinancialItemLineMergeDataSchema = getSchema(FinancialItemLineMergeData);